import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import type { SuggestedPromptGroup } from "../../types/types";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: ${({ theme }) => theme.resolve("spacing_lg")}
    ${({ theme }) => theme.resolve("spacing_xs")};
`;

const GroupLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.primaryTextColor};
  opacity: 0.7;
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.resolve("spacing_sm")};
`;

const PromptChip = styled.button`
  background-color: white;
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.primaryBorder};
  border-radius: ${({ theme }) => theme.resolve("radius_2xl")};
  padding: ${({ theme }) => theme.resolve("spacing_sm")}
    ${({ theme }) => theme.resolve("spacing_lg")};
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  color: ${({ theme }) => theme.primaryTextColor};
  &:hover {
    background-color: ${({ theme }) =>
      theme.resolve("color_bg_surface_brand_mixed")};
    border-color: ${({ theme }) => theme.brandColor};
  }
`;

const Intro = styled.div`
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  color: ${({ theme }) => theme.primaryTextColor};
  margin-bottom: ${({ theme }) => theme.resolve("spacing_xs")};
  font-weight: 500;
`;

export function SuggestedPrompts({
  onPick,
  groups,
  intro,
}: {
  onPick: (prompt: string) => void;
  groups?: SuggestedPromptGroup[];
  intro?: string;
}) {
  const { t } = useTranslation();
  const resolvedGroups = groups ?? [];
  const resolvedIntro = intro ?? t("Hello, How may I help you");

  return (
    <Wrapper>
      <Intro>{resolvedIntro}</Intro>
      {resolvedGroups.map((g) => (
        <div key={g.label}>
          <GroupLabel>{g.label}</GroupLabel>
          <ChipRow style={{ marginTop: 6 }}>
            {g.prompts.map((p) => (
              <PromptChip key={p} type="button" onClick={() => onPick(p)}>
                {p}
              </PromptChip>
            ))}
          </ChipRow>
        </div>
      ))}
    </Wrapper>
  );
}
